import React from "react";
import PropTypes from "prop-types";
import "./index.scss";

import { WidgetComponents } from "@learningblocks/shared-components/lib/WidgetComponents";

const { Slider, RangeSlider, RangeSliderLabels } = WidgetComponents;

export function MicroscopeSlider(props) {
  return (
    <Slider>
      <RangeSliderLabels left={props.leftLabel} right={props.rightLabel} />
      {(props.leftLabel || props.rightLabel) && (
        <div style={{ height: "10px" }} />
      )}
      <RangeSlider
        min={props.min}
        max={props.max}
        step={props.step}
        value={props.value}
        onSliderChange={props.onSliderChange}
        ariaLabel={props.ariaLabel}
      />
    </Slider>
  );
}

MicroscopeSlider.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  value: PropTypes.number,
  step: PropTypes.number,
  onSliderChange: PropTypes.func | undefined,
  ariaLabel: PropTypes.string,
};

MicroscopeSlider.defaultProps = {
  className: "",
};
